import { Injectable } from '@angular/core';
import { isUndefined } from 'util';
import { FiScrollToElementAnimateService } from '@fi-shared/fi-shared-services/scroll-to-element-animate.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { IChecklistReportData } from '@fi-app/checklist-report/checklist-report';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { IChartClickEvent } from '@fi-shared/fi-chart/fi-chart';

@Injectable()
export class ChecklistReportHelperService {
    constructor(
        private fiScrollToElementAnimateService: FiScrollToElementAnimateService,
        private stateService: FiStateService,
    ) {}

    // chart.js related click handler
    onChartClick($event: IChartClickEvent, callback: (index: number) => void) {
        if ($event.active && $event.active.length) {
            const idx = ($event.active[0] as any).index;
            callback(idx);
        }
    }

    canSelectStatus(status, reportData: IChecklistReportData) {
        if (!reportData) return false;

        return reportData.Statuses.filter(function (data) {
            return data.Status === status && data.UnitCheckPointDetails.length;
        }).length;
    }

    selectStatus(status, reportData: IChecklistReportData, reportId: number) {
        if (!this.canSelectStatus(status, reportData)) return;

        this.stateService.go(
            FiStateNames.Checklist.Report.View,
            {
                Id: reportId,
                status: status,
            },
            { location: 'replace', inherit: false },
        );

        if (status) this.tryScrollToId('report-checkpoints-per-unit');
    }

    private checkpointsOnUnitLoaded$ = new Subject<void>();
    selectBusinessUnit(unitId: number) {
        this.stateService.go(
            this.stateService.current.name,
            { unitId: unitId },
            { location: 'replace', notify: false },
        );
        this.checkpointsOnUnitLoaded$.pipe(first()).subscribe(() => {
            this.tryScrollToId('report-checkpoints-on-unit');
        });
    }

    raiseCheckpointsOnUnitLoadedEvent() {
        this.checkpointsOnUnitLoaded$.next();
    }

    tryScrollToId(id, nTries?) {
        if (isUndefined(nTries)) nTries = 100;

        const scrollTo = document.getElementById(id);
        if (scrollTo) {
            this.fiScrollToElementAnimateService.scrollTo(scrollTo, document.getElementById('report-view-scrollable'));
        } else if (nTries > 0) {
            setTimeout(this.tryScrollToId.bind(this), 50, id, nTries - 1);
        }
    }
}
